// extracted by mini-css-extract-plugin
export var closeButton = "_kv-1";
export var closeX = "_kv-3";
export var container = "_kv-0";
export var image = "_kv-2";